export const HASH_NO_EXTENSION = "#noExtension";
export const HASH_EXTENSION_UNAVAILABLE = "#extensionUnavailable";
export const GENERIC_CONNECTOR_ID = 77068;
export const ROOT_PATH = "/portal";
export const APP_STORE_PATH = `${ROOT_PATH}/store`;
export const HELP_PATH = `${ROOT_PATH}/help`;
